export const HTML_IMAGE_SELECTOR = 'img';
const IMAGE_ATTRIBUTES = ['src', 'alt', 'loading', 'fetchpriority', 'decoding', 'srcset', 'sizes', 'width', 'height'];
const SOURCE_ATTRIBUTES = ['srcset', 'media', 'type', 'sizes'];

const parse = html => {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    return template;
};
const attributes = (element, names) => Object.fromEntries(names.map(name => [name, element.getAttribute(name) ?? '']));
const sourcesOf = image => image.parentElement?.tagName === 'PICTURE'
    ? Array.from(image.parentElement.children).filter(node => node.tagName === 'SOURCE') : [];

export const findHtmlImageIndex = (root, target) => {
    const element = target?.closest?.('img, picture');
    const image = element?.tagName === 'PICTURE' ? element.querySelector('img') : element;
    return image && root.contains(image) ? Array.from(root.querySelectorAll(HTML_IMAGE_SELECTOR)).indexOf(image) : -1;
};

export const getHtmlImageSelection = (html, index) => {
    const image = parse(html).content.querySelectorAll(HTML_IMAGE_SELECTOR)[index];
    if (!image) return null;
    return {
        ...attributes(image, IMAGE_ATTRIBUTES),
        sources: sourcesOf(image).map((source, originalIndex) => ({ originalIndex, ...attributes(source, SOURCE_ATTRIBUTES) })),
    };
};

const updateAttributes = (element, values, names) => {
    for (const name of names) {
        const value = values[name] ?? '';
        if (value === '' && name !== 'alt') element.removeAttribute(name);
        else element.setAttribute(name, value);
    }
};

export const updateHtmlImage = (html, index, values) => {
    const template = parse(html);
    const image = template.content.querySelectorAll(HTML_IMAGE_SELECTOR)[index];
    if (!image) return html;
    updateAttributes(image, values, IMAGE_ATTRIBUTES);
    const oldSources = sourcesOf(image);
    let picture = image.parentElement?.tagName === 'PICTURE' ? image.parentElement : null;
    if (values.sources.length && !picture) {
        picture = document.createElement('picture');
        // A wrapper must not introduce an extra layout box around a previously standalone image.
        picture.style.display = 'contents';
        image.replaceWith(picture);
        picture.append(image);
    }
    if (picture) {
        const nextSources = values.sources.map(source => {
            const element = Number.isInteger(source.originalIndex) && oldSources[source.originalIndex]
                ? oldSources[source.originalIndex].cloneNode(true) : document.createElement('source');
            updateAttributes(element, source, SOURCE_ATTRIBUTES);
            return element;
        });
        oldSources.forEach(source => source.remove());
        nextSources.forEach(source => picture.insertBefore(source, image));
    }
    return template.innerHTML;
};
